export default "__VITE_ASSET__D6Xng5b4__"